import React from 'react';
import {
  Row,
  Col,
  Card,
  CardContent,
  FormField,
  Input,
  Translate,
  SwitchButton,
  Seperator,
  Button,
  Icon,
  RadioBoxList,
  AreaPicker,
  TimeField,
  FormRenderer,
  ToggleButton,
  DatePicker,
  CheckBox
} from "$common";
import CSSModules from 'react-css-modules';
import style from '../create.scss';
import AgeGroups from '$constants/age-groups.json';
import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';

const Targeting = props => (
  <Card>
    <CardContent extraPadding>
      <Seperator style={{ marginTop: '26px' }} extraContent={
        <FormField name="is_targeting_enabled" label={Translate.get('custom')}>
          <SwitchButton />
        </FormField>
      }>
        {Translate.get('targeting_title')}
      </Seperator>
      {
        props.project.targetings.map( (targeting, index) => !targeting._destroy ? (
          props.project.is_targeting_enabled ?
            <div styleName="target-group" key={index}>
              <Row>
                <Col md="3/10">
                  <div styleName="gender">
                    <p>{Translate.get('gender')}</p>
                    <ToggleButton
                      name={`targetings[${index}][gender][male]`}
                      type="white-ghost"
                      selectedType="ghost"
                      label={
                        <img src={require('$shared/images/audience/male.svg')} />
                      }
                    />
                    <ToggleButton
                      name={`targetings[${index}][gender][female]`}
                      type="white-ghost"
                      selectedType="ghost"
                      label={
                        <img src={require('$shared/images/audience/female.svg')} />
                      }
                    />
                  </div>
                </Col>
                <Col md="3/10">
                  <div styleName="age">
                    <p>{Translate.get('age_range')}</p>
                    {
                      targeting.is_custom_age_range_enabled ?
                        <Row>
                          <Col md="1/2">
                            <FormField name={`targetings[${index}][min_age]`}>
                              <Input type="number" placeholder={Translate.get('min')}/>
                            </FormField>
                          </Col>
                          <Col md="1/2">
                            <FormField name={`targetings[${index}][max_age]`}>
                              <Input type="number" placeholder={Translate.get('max')}/>
                            </FormField>
                          </Col>
                        </Row>
                      :
                        Object.keys(AgeGroups).map( (item, itemIndex) => (
                          <Tooltip placement="top" overlay={<div>{AgeGroups[item][0]}...{AgeGroups[item][1]}</div>} key={itemIndex}>
                            <div style={{ display: 'inline-block' }}>
                              <ToggleButton
                                name={`targetings[${index}][age_range][${item}]`}
                                label={Translate.get(item)}
                              />
                            </div>
                          </Tooltip>
                        ))
                    }
                    <div styleName="custom-age-range">
                      <FormField name={`targetings[${index}][is_custom_age_range_enabled]`} label={Translate.get('custom_age_range')}>
                        <CheckBox />
                      </FormField>
                    </div>
                  </div>
                </Col>
                <Col md={`${props.project.targetings.length > 1 ? '5/16' : '6/16'}`}>
                  <div styleName="quota">
                    <p>{Translate.get('quota_title')}</p>
                    <FormField name={`targetings[${index}][max_submission_count]`}>
                      <Input type="number"/>
                    </FormField>
                  </div>
                </Col>
                {
                  props.project.targetings.length > 1 ?
                    <Col md="1/16">
                      <FormField label="&nbsp;">
                        <Button
                          block
                          type="danger-ghost"
                          style={{ float: 'right', height: '48px', marginTop: '10px' }}
                          onClick={() => props.removeTargetingGroup(index)}
                        >
                          <Icon name="times" />
                        </Button>
                      </FormField>
                    </Col>
                    : ''
                }
              </Row>
            </div>
            :
            <div styleName="target-group" key={index}>
              <Row>
                <Col md="2/6">
                  <FormField name={`targetings[${index}][gender]`} label={Translate.get('gender')}>
                    {
                      Object.keys(targeting.gender).map( (gender, genderIndex) => targeting.gender[gender] ? (
                        <span styleName="target-info" key={genderIndex}>{Translate.get(gender)}</span>
                      ) : null)
                    }
                  </FormField>
                </Col>
                <Col md="2/6">
                  <FormField name={`targetings[${index}][age_range]`} label={Translate.get('age_range')}>
                    {
                      Object.keys(targeting.age_range).map( (age_range, ageRangeIndex) => targeting.age_range[age_range] ? (
                        <span styleName="target-info" key={ageRangeIndex}>{age_range}</span>
                      ) : null)
                    }
                  </FormField>
                </Col>
                <Col md="2/6">
                  <FormField name={`targetings[${index}][max_submission_count]`} label={Translate.get('quota_title')}>
                    <p>{targeting.max_submission_count}</p>
                  </FormField>
                </Col>
              </Row>
            </div>
        ) : null)
      }
      {
        props.project.is_targeting_enabled &&
        <Button
          type="success"
          onClick={() => props.addTargetingGroup()}
        >
          <Icon name="plus" /> {Translate.get('add_targeting_group')}
        </Button>
      }
      <Seperator>{Translate.get('scheduling_title')}</Seperator>
      <Row>
        <Col md="1/2">
          <FormField name="scheduleProject" label={Translate.get('schedule')}>
            <RadioBoxList
              options={[
                { label: Translate.get('schedule_false_label'), value: false },
                { label: Translate.get('schedule_true_label'), value: true }
              ]}
            />
          </FormField>
          <FormRenderer
            content={values => {
              return (
                values.scheduleProject ? (
                  <div>
                    <Row>
                      <Col sm="20px"></Col>
                      <Col basis="0">
                        <Card>
                          <CardContent>
                            <Row>
                              <Col sm="1/5" vertical="center">
                                {Translate.get('starts')}
                              </Col>
                              <Col sm="4/5">
                                <DatePicker
                                  name="scheduling[starts_at]"
                                  withTime
                                />
                              </Col>
                            </Row>
                            <br />
                            <Row>
                              <Col sm="1/5" vertical="center">
                                {Translate.get('ends')}
                              </Col>
                              <Col sm="4/5">
                                <DatePicker
                                  name="scheduling[finishes_at]"
                                  withTime
                                />
                              </Col>
                            </Row>
                          </CardContent>
                        </Card>
                      </Col>
                    </Row>
                    <br />
                  </div>
                ) : null
              )
            }}
          />
        </Col>
        <Col md="1/2">
          <FormField name="limitAvailability" label={Translate.get('availability')}>
            <RadioBoxList
              options={[
                { label: Translate.get('availability_false_label'), value: false },
                { label: Translate.get('availability_true_label'), value: true }
              ]}
            />
          </FormField>
          <FormRenderer
            content={values => {
              return (
                values.limitAvailability ? (
                  <Row>
                    <Col sm="20px"></Col>
                    <Col basis="0">
                      <Card>
                        <CardContent>
                          <Row>
                            <Col sm="1/5" vertical="center">
                              {Translate.get('day')}
                            </Col>
                            <Col sm="4/5">
                              <ToggleButton name="availability[available_on_monday]" label="M" />&nbsp;
                              <ToggleButton name="availability[available_on_tuesday]" label="T" />&nbsp;
                              <ToggleButton name="availability[available_on_wednesday]" label="W" />&nbsp;
                              <ToggleButton name="availability[available_on_thursday]" label="T" />&nbsp;
                              <ToggleButton name="availability[available_on_friday]" label="F" />&nbsp;
                              <ToggleButton name="availability[available_on_saturday]" label="S" />&nbsp;
                              <ToggleButton name="availability[available_on_sunday]" label="S" />
                            </Col>
                          </Row>
                          <br />
                          <Row>
                            <Col sm="1/5" vertical="center">
                              {Translate.get('hour')}
                            </Col>
                            <Col sm="4/5">
                              {Translate.get('from')} &nbsp;
                              <TimeField name="availability[available_from]" />
                              &nbsp; {Translate.get('to')} &nbsp;
                              <TimeField name="availability[available_to]" secondary />
                            </Col>
                          </Row>
                        </CardContent>
                      </Card>
                    </Col>
                  </Row>
                ) : null
              )
            }}
          />
        </Col>
      </Row>
      <Seperator style={{ marginTop: '26px' }} extraContent={
        <FormField name="is_geo_configuration_enabled" label={Translate.get('custom')}>
          <SwitchButton />
        </FormField>
      }>
        {Translate.get('geo_configuration_title')}
      </Seperator>
      <FormField name="area_id">
        {
          props.project.is_geo_configuration_enabled || props.project.area_id ?
            <AreaPicker height="550px" />
          : null
        }
      </FormField>
    </CardContent>
  </Card>
)

export default CSSModules(Targeting, style, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/projects/create/steps/targeting.js